import { render, staticRenderFns } from "./IncomingTabContent.vue?vue&type=template&id=cf2a19c8&scoped=true&"
import script from "./IncomingTabContent.vue?vue&type=script&lang=js&"
export * from "./IncomingTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2a19c8",
  null
  
)

export default component.exports